import { PaymentsActivityRoute } from "route-components/PaymentsActivityRoute";
import { createFileRoute } from "@tanstack/react-router";
import { getPaymentsActivityDefaultSearch } from "utils/routeDefaults";
import type { PaymentsActivityStatusFilterType } from "components/PaymentsLanding/Tabs/PaymentsActivity/PaymentsActivityBar/paymentsActivityStatusFilterHelpers";
import type { TransactionSource } from "api/responses";

export interface PaymentsActivitySearchParams {
    patientName: string;
    statuses: PaymentsActivityStatusFilterType[];
    sources: TransactionSource[];
}

export type PaymentsActivitySearchParamsPartial = Partial<PaymentsActivitySearchParams>;

export const Route = createFileRoute("/history/payments")({
    component: PaymentsActivityRoute,
    validateSearch: getPaymentsActivityDefaultSearch,
});
